import { render } from "./InstructorDashboard.vue?vue&type=template&id=46001f87&scoped=true"
import script from "./InstructorDashboard.vue?vue&type=script&lang=js"
export * from "./InstructorDashboard.vue?vue&type=script&lang=js"

import "./InstructorDashboard.vue?vue&type=style&index=0&id=46001f87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46001f87"]])

export default __exports__